<input
  #inputDireccion
  class="direccion"
  type="text"
  placeholder="Avenida Siempre Viva 742 / Escuela San Benito"
  [(ngModel)]="direccion"
  [ngModelOptions]="{ standalone: true }"
  [matAutocomplete]="auto"
/>
<mat-autocomplete #auto="matAutocomplete">
  @for (p of preddiciones; track p) {
    <mat-option [value]="p" (click)="onClick()">
      {{ p }}
    </mat-option>
  }
</mat-autocomplete>
